































































import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants.ts";
import { Utilities as utils } from "@/shared/utilities";
import { http } from "@/shared/https";
import AuthService from '@/services/auth.service';
import { User } from 'oidc-client';
import { Locales } from "@/i18n/locales";
const auth = new AuthService();

import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";

@Component({
  components: {},
})
export default class ExternalReviewListComponent extends Vue {
  reviews: Array<any> = [];
  readonlyStatus = [
    _app.reviewStatus.COI_Rejected,
    _app.reviewStatus.Submitted,
  ];
  programs = _app.programs
  grantType = _app.grantType;
  actions = _app.actions;
  subjects = _app.subjects;
  //   inProgressStatus = [_app.reviewStatus.In_Progress];
  @Action("resetAppState", { namespace: "application" }) resetAppState: any;
  @Action("setApplicationId", { namespace: "application" }) setApplication: any;
  @Action("getCategories", { namespace: "reviewForm" }) getCategories: any;
  @Action("setApplicationId", { namespace: "reviewExternal" }) beginReview: any;
  @Action("setReviewId", { namespace: "reviewExternal" }) setReviewId: any;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  @Getter("_appUserId", { namespace: "RootApp"}) _userid!: number;
  @Action("create", { namespace: "reviewForm" }) createReview: any;
  @Prop() items: any;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  mounted() {
  }

  /** List reviews on page load */
  // listProposal() {
  //   return this.$services.review.listProposals();
  // }
  buttonVisibility(card, context) {
    let show = false;
    switch (context) {
      case 'review':
        //@ts-ignore
        if (!this.readonlyStatus.includes(card.ReviewStatusId) && this._userid == card.ReviewerId && ((this.$can(this.actions.fullaccess, this.subjects.all) ||this.$can(this.actions.read, this.subjects.ragReview)) || (card.GrantTypeId == this.grantType.TSG && card.ProgramId == this.programs.tiger && this.$can(this.actions.manage, this.subjects.externalReview)))) {
          show = true;
        }
        break;
      case 'view':
        //@ts-ignore
        if (card.ReviewStatusId !== null && (!this.readonlyStatus.includes(card.ReviewStatusId) || this._userid != card.ReviewerId || ((this.$can(this.actions.fullaccess, this.subjects.all) ||this.$can(this.actions.read, this.subjects.ragReview)) || (card.GrantTypeId == this.grantType.TSG && card.ProgramId == this.programs.tiger && this.$can(this.actions.manage, this.subjects.externalReview))))) {
          show = true;
        }
        break;
      case 'download':
        if (card.ReviewStatusId) {
          show = true;
        }
        break;
    }
    return show;
  }

  /** Download Pdf*/
  downloadPdf(item: any) {
    let self = this;
    let categoryList = [],
      modelData,
      formData;
    if (item.ExternalReviewId) {
      this.$services.review
        .getReportData(item.ExternalReviewId, item.Entity)
        .then((resp) => {
          if (resp.status >= 200 && resp.status < 300) {
            self.getCategories({ id: resp.data.metadata.ApplicationId, entity: item.Entity }).then(
              (catg) => {
                this.$services.tagReviewReport.generate({
                  data: resp.data.review,
                  categories: catg,
                  metadata: resp.data.metadata,
                  user: self._username,
                });
              }
            );
          }
        });
    }
  }

  /** Edit Proposal */
  editProposal(item) {
    let self = this;
    auth.isLoggedIn().then((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          auth.getUser().then((user: User) => {
            if (self.readonlyStatus.includes(item.ReviewStatusId)) {
              let routeData = this.$router.resolve({
                name: "viewTagReview",
                query: { reviewerId: item.ReviewerId, applicationId: item.uniqueID, entity: item.Entity }
              });

              window.open(routeData.href, "_blank");
            } else if (user.profile.sub == item.ReviewerId) {
              this.$router.push({
                name: "reviewApplication",
                params: { reviewerId: user.profile.sub, applicationId: item.uniqueID, entity: item.Entity}
              });
            } else {
              let routeData = this.$router.resolve({
                name: "viewTagReview",
                query: { reviewerId: item.ReviewerId, applicationId: item.uniqueID, entity: item.Entity }
              });

              window.open(routeData.href, "_blank");
            }
          });
        }
    });
  }

  startReview(item) {
    this.editProposal(item);
  }

  formatCurrency(val, currency) {
    if (typeof(val) === "string") {
      return val;
    }

    return utils.formatCurrency(val, currency, this.defaultLocale);
  }
}
